import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import '../scss/qr-style.scss';

import Brand from './style-components/Brand';
import Color from './style-components/Color';
import QRSize from './style-components/QRSize';
import Style from './style-components/Style';
import Text from './style-components/Text';

interface MenuType {
  id: number;
  title: string;
  component: JSX.Element;
}

/**
 * QR Style Component
 * @param {any} param0 - The param0
 * @param {any} param0.qrValues - The qrValues prop
 * @param {any} param0.setQrValues - The setQrValues prop
 * @returns {any} The result
 */
function QrStyle({ qrValues, setQrValues }: any) {
  const { t } = useTranslation('qrCode');
  const [menu, setMenu] = useState<MenuType[] | number>(0);

  const component = [
    {
      id: 1,
      title: t('styles'),
      component: <Style qrValues={qrValues} setQrValues={setQrValues} />,
    },
    {
      id: 2,
      title: t('color'),
      component: <Color qrValues={qrValues} setQrValues={setQrValues} />,
    },
    {
      id: 3,
      title: t('text'),
      component: <Text qrValues={qrValues} setQrValues={setQrValues} />,
    },
    {
      id: 4,
      title: t('brand'),
      component: <Brand qrValues={qrValues} setQrValues={setQrValues} />,
    },
    {
      id: 5,
      title: t('qrSize'),
      component: <QRSize qrValues={qrValues} setQrValues={setQrValues} />,
    },
  ];

  /**
   * Function For Updating Component to State
   * @param {any} id - The id
   */
  const handleSelect = (id: any) => {
    setMenu(id);
  };

  return (
    <div className="qr-style-wrap">
      {component.map((comp) => (
        <>
          <div className="qr-menu">
            <p role="presentation" className="menu" onClick={() => handleSelect(comp.id)}>
              {comp.title}
            </p>
          </div>
          <div>
            {menu === comp.id ? <div className="qr-menu-comp">{comp.component}</div> : null}
          </div>
        </>
      ))}
    </div>
  );
}

export default QrStyle;
